'use strict';

module.exports = ['$scope', '$modalInstance', 'config', '$http', function ($scope, $modalInstance, config, $http) {
    // ------------------
    // Scope
    // ------------------
    $scope.ok = function () {
        var formData = {
            customers: $scope.customers,
        };

        $scope.disableInput = true;

        $http.post('/plant/'+$scope.plantId+"/customers_upload/", formData).success(function (data) {
            $modalInstance.close(data);
            $scope.disableInput = false;
        }).error(function (data) {
            $scope.error = data;
            $scope.disableInput = false;
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    function init() {
        $scope.customers = config.customers;
        $scope.plantId = config.plantId;
    }

    init();

}];